import { render, staticRenderFns } from "./AddParcelDialog.vue?vue&type=template&id=29394083&scoped=true"
import script from "./AddParcelDialog.vue?vue&type=script&lang=js"
export * from "./AddParcelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29394083",
  null
  
)

export default component.exports